/* eslint-disable max-lines */

import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import * as React from 'react';

const AutofocusPlugin: React.FC = () => {
  const [editor] = useLexicalComposerContext();

  React.useLayoutEffect(() => {
    editor.focus();
  }, [editor]);

  return null;
};

export default AutofocusPlugin;
